import { useAuth } from '@app/hooks';
import React, { useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATH_AUTH } from './paths';

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null,
  );

  const auth = useMemo(() => isAuthenticated(), [isAuthenticated]);

  console.log('auth', auth);

  const { pathname } = useLocation();

  if (!auth) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={pathname} />;
  }

  return <>{children}</>;
};

export default AuthGuard;
